import Chapter from "./Chapter";
import Counter from "./Counter";
import { Clock, Award, ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../constants/site";

const CHAPTERS = [
  {
    index: "01",
    kicker: "The Vision",
    title: "A district, not just a tower",
    paragraphs: [
      "Sugee Lake District anchors Thane's N.I.C.E. — New India's City of Economic Growth: a 52-acre mixed-use ecosystem around Siddheshwar Lake, crowned by a 35-floor Grade A+ office tower.",
    ],
    image: IMAGES.elevTop,
    flip: false,
  },
  {
    index: "02",
    kicker: "The Address",
    title: "One hour to everything",
    paragraphs: [
      "Opposite Korum Mall, at Cadbury Junction — the Eastern Express Highway in a minute, the metro in three, and one of Maharashtra's four bullet-train hubs within reach.",
    ],
    image: IMAGES.skyReflection,
    flip: true,
  },
  {
    index: "03",
    kicker: "The Architecture",
    title: "Engineered for enterprise",
    paragraphs: [
      "Thirty-five Grade A+ floors, column-efficient plates and 4.2 m internal heights — bare-shell and warm-shell suites from 800 to 46,000 sq. ft.",
    ],
    image: IMAGES.elevMid,
    flip: false,
  },
];

const STATS = [
  [52, "", "Acre integrated development"],
  [35, "", "Floors of Grade A+ offices"],
  [11, "+", "Lifestyle amenities"],
  [1, "st", "Commercial landmark of Thane"],
];

const PROMISES = [
  { icon: Clock, label: "Always Delivered On Time" },
  { icon: Award, label: "Highest Construction Quality" },
  { icon: ShieldCheck, label: "Strict Compliance To Approvals" },
];

export default function Manifesto() {
  return (
    <div id="vision" data-testid="manifesto-section">
      {CHAPTERS.map((c) => (
        <Chapter key={c.index} {...c} />
      ))}
      <div className="max-w-screen-2xl mx-auto px-6 pb-24">
        <Reveal>
          <div className="grid grid-cols-2 md:grid-cols-4 border-t border-border">
            {STATS.map(([num, suffix, label], i) => (
              <div
                key={label}
                data-testid={`stat-${i}`}
                className="border-l first:border-l-0 border-border p-8 md:p-10"
              >
                <p className="font-display font-semibold text-4xl md:text-5xl text-primary">
                  <Counter value={num} suffix={suffix} />
                </p>
                <p className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mt-3">{label}</p>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="grid md:grid-cols-3 border border-border mt-6">
            {PROMISES.map(({ icon: Icon, label }, i) => (
              <div
                key={label}
                data-testid={`promise-${i}`}
                className="flex items-center gap-4 p-6 border-b md:border-b-0 md:border-l first:border-l-0 border-border hover:bg-primary/5 transition-colors"
              >
                <Icon size={20} className="text-primary shrink-0" strokeWidth={1.5} />
                <p className="text-[11px] uppercase tracking-[0.2em] text-foreground/80">{label}</p>
              </div>
            ))}
          </div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mt-6">
            Iconic Ultra-Luxury Project 2025–26 · Times Real Estate Conclave — Sugee Sea Krest
          </p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mt-3">
            Architect: Padma Bhushan Hafeez Contractor · Structural: Sterling Engineering · Peer Review: SOM
          </p>
        </Reveal>
      </div>
    </div>
  );
}
